(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name commons.directive:checkPrivilege
   * @restrict EA
   * @element
   *
   * @description
   * to check the privilege and hide the element.
   * @example
     <example module="commons">
       <file name="index.html">
        <div check-privilege='[privilage_to_check]'></div>
       </file>
     </example>
   *
   */
  angular
    .module('commons')
    .directive('checkPrivilege', checkPrivilege);

  function checkPrivilege(UserPrivilegesService) {
    return {
      restrict: 'EA',
      replace: false,
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
        if (attrs.checkPrivilege!==undefined){
          UserPrivilegesService.registerPrivilegeExeStack(attrs.checkPrivilege, function(){
            if (UserPrivilegesService.checkPrivilege(attrs.checkPrivilege)){
              element.addClass('ng-show');
            }else{
              element.addClass('ng-hide');
            }
          });
        }
      }
    };
  }
}());
